module.exports = __webpack_public_path__ + "img/number.e4a4a9de.svg";